import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import type { LeaderboardItemType } from "../components/Leaderboard/types";
import type { DashboardData, InsightsData } from "./schema";

export type PeriodType = "all_time" | "week" | "month";
type LeaderboardParams = {
	periodType: PeriodType;
	projectId: number;
	userPublicMetadataId: number;
	organizationId: number;
};
type Params = {
	itemId?: number;
	userId: number;
	collectionId?: number;
	token: string;
	tenantId: string;
	projectId: number;
	organizationId: number;
};

export const fetchLeaderboardItems = async ({
	periodType,
	projectId,
	organizationId,
}: LeaderboardParams): Promise<LeaderboardItemType[]> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/assessments/v1/users/leaderboard?projectId=${projectId}&organizationId=${organizationId}&periodType=${periodType}&limit=10`,
	);

	return data.data.leaderboard;
};

export const fetchUserRank = async ({
	periodType,
	projectId,
	organizationId,
	userPublicMetadataId,
}: LeaderboardParams): Promise<LeaderboardItemType> => {
	const { data } = await authAxios.get(
		`${API_BASE_URL}/assessments/v1/users/leaderboard/${userPublicMetadataId}/rank?projectId=${projectId}&organizationId=${organizationId}&periodType=${periodType}`,
	);

	return data.data.leaderboardUserRecord;
};
export const fetchDashboardItems = async ({
	userId,
	token,
	tenantId,
	collectionId,
}: {
	userId: number;
	token: string;
	tenantId: string;
	collectionId: number;
}): Promise<DashboardData> => {
	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/users/get-items-for-dashboard`,
		{
			collectionId,
			action: "LIBRARY",
			type: "QUESTION",
			userId,
		},
		{
			headers: {
				Authorization: token,
				tenantId,
			},
		},
	);

	return data;
};

export const fetchInsights = async (params?: Params): Promise<InsightsData> => {
	const {
		itemId,
		userId,
		collectionId,
		token,
		tenantId,
		projectId,
		organizationId,
	} = params ?? {};

	const { data } = await authAxios.post(
		`${API_BASE_URL}/assessments/v1/users/progress`,
		{
			projectId,
			userId,
			versionId: 1,
			itemId,
			organizationId,
			collectionId,
		},
		{
			headers: {
				Authorization: token,
				tenantId,
			},
		},
	);

	return data;
};
